import { FTNFTAmCheckout } from './FTNFTAmCheckout';
import { VeniceCheckout } from './VenicCheckout';
import { IS_KIOSK_VENICE_MODE } from 'constants/app/configs';

export const NftCheckoutView = () => {
  return IS_KIOSK_VENICE_MODE ? <VeniceCheckout /> : <FTNFTAmCheckout />;
};
